import { useEffect } from 'react'

import { useEducationHostedForm } from '../useEducationHostedForm/useEducationHostedForm'

export const useRedirectUserAfterComplete = (shouldRedirect: boolean, delaySeconds: number) => {
  const { partnerConfig } = useEducationHostedForm()

  useEffect(() => {
    const timer = setTimeout(() => {
      if (shouldRedirect && partnerConfig?.redirectUrl) {
        window.location.href = partnerConfig?.redirectUrl
      }
    }, delaySeconds * 1000)

    return () => clearTimeout(timer)
  }, [partnerConfig?.redirectUrl, shouldRedirect, delaySeconds])
}
